module.exports = __webpack_public_path__ + "images/emoji/abc.8c4f1c2f7d2d21b02eb6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/abc.png
// module id = 9pB5
// module chunks = 14